import React from "react";
import "./css/style.css";
const Loader = () => {
  return (
    <div class="outside-loader">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};

export default Loader;
